<template>
  <v-card-text class="px-4 pt-0">
    <p class="my-3">
      <strong
        >Der er indført nye regler for beskyttelse af personlige oplysninger –
        derfor modtager du denne popup</strong
      >
    </p>
    <p class="termsP">
      Ved ibrugtagning af StokerCloud accepterer du følgende betingelser
    </p>
    <ul class="termsUl">
      <li>
        Brug af StokerCloud er på eget ansvar. StokerCloud gør det muligt at
        justere parametre som har indvirkning på fyrets funktion. Sørg derfor
        ALTID for, at være i samme lokale som fyret når der foretages
        justeringer. Foretag aldrig ændringer i et fyr som ikke er under fysisk
        overvågning.
      </li>
      <li>
        Vi understreger at annullering af alarm absolut ikke må udføres med
        mindre du er helt klar over hvorfor alarmen er tilstede, samt har
        mulighed for efterfølgende fysisk overvågning af fyret.
      </li>
      <li>
        Stokersoft/NBE kan ikke holdes ansvarlig for evt. følgeeffekter af
        forkert satte værdier, som både er sat tilsigtet og utilsigtet evt. som
        følge af fejl og andre forhold i StokerCloud softwaren.
      </li>
      <li>
        Er man i tvivl om opsætning via StokerCloud bør man benytte fyrets
        fysiske styring til justeringer, og alene benytte StokerCloud til
        overvågning.
      </li>
      <li>
        Der kan forekomme svigt på StokerCloud servicen, disse vil forsøgt
        udbedret hurtigst muligt. Stokersoft/NBE kan ikke holdes ansvarlig for
        tab som følge af manglende forbindelse, ikke fremsendte SMSer, emails
        mv.
      </li>
      <li>
        Enhver form for hacking, herunder simpel tilegnelse af andre brugeres
        kodeord medfører politianmeldelse og permanent udelukkelse fra servicen.
      </li>
      <li>Vi bruger cookies og siden virker ikke uden din accept.</li>
      <li>Vedrørende beskyttelse af dine personlige oplysninger</li>
      <li>
        <ul>
          <li>
            - For at have en konto, skal du registrere email, navn og adresse.
            Ved brug af servicen logges IP adresser på benyttede enheder og
            fyret.
          </li>
          <li>- Oplysningerne benyttes i supportsammenhænge.</li>
          <li>
            - På stokercloud.dk kan du logge ind på din konto og se alle
            registrerede oplysninger, alternativt kan sendes en email til
            support@nbe.dk med overskriften “Send oplysninger for xxxxxx;” hvor
            xxxxxx er serienummeret på styringen
          </li>
          <li>
            - Din konto kan lukkes ved at sende en email til support@nbe.dk med
            overskriften “Luk konto for xxxxxx” hvor xxxxxx er serienummeret på
            styringen. Ved lukning af konto slettes alle oplysninger
            øjeblikkeligt.
          </li>
          <li>
            - Ved oprettelse af konto, accepterer du at vi kan rette henvendelse
            på email, telefon og brev i forbindelse med service og support –
            ikke i forbindelse med salgsmæssige aktiviteter.
          </li>
          <li>- Ingen oplysninger videregives eller sælges til trediepart.</li>
        </ul>
      </li>
    </ul>
  </v-card-text>
</template>
<script>
export default {
  name: "TermsDK"
};
</script>
